import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

import { fetchEntitledChannels } from './fetchEntitledChannels';

export function fetchEntitledChannelsQuery() {
  return queryClient.fetchQuery({
    queryKey: queryKeys.entitledChannels,
    queryFn: fetchEntitledChannels,
    staleTime: Infinity,
  });
}
